export default __webpack_public_path__ + "static/wfm-meta-72faed42c25b24905d2e6f0aead3f62f.png";